<template>
  <div
    class="modal fade"
    :id="`commentsModal-${playlist_id}`"
    tabindex="-1"
    role="dialog"
    aria-labelledby="commentsModalLabel"
    aria-hidden="true"
  >
    <div
      class="modal-dialog"
      role="document"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h5
            class="modal-title"
            id="commentsModalLabel"
          >
            Comments
          </h5>
          <button
            type="button close-btn"
            @click="handleHideModal()"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
            style="
              background-color: transparent !important;
              border: 1px solid;
              border-radius: 5px !important;
            "
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div
          class="chat-body"
          v-chat-scroll
        >
          <div
            class="chat-body-message"
            v-for="message in comments"
            :key="message.id"
          >
            <img
              src="https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460__340.png"
              class="user-profile"
              alt=""
              srcset=""
            />
            <div class="chat-body-message-content">
              <span class="sender-name"
                >{{
                  message.commentator.firstname +
                  ' ' +
                  message.commentator.lastname
                }}
                {{ ' • ' }}
              </span>
              {{ message.comment }}
            </div>
          </div>
        </div>
        <form
          method="post"
          action="#"
          @submit.prevent="send_message"
          class="chat-footer"
          v-if="!hide"
        >
          <!--      User needs to be  logged in warning-->
          <div
            class="chat-footer-warning"
            v-if="!isAuth"
          >
            <i class="fas fa-exclamation-triangle"></i>
            <span>{{ loginToChatLang }}</span>
          </div>

          <div
            class="chat-footer-input"
            v-if="isAuth"
          >
            <input
              type="text"
              v-model="message"
              placeholder="Type a message..."
            />
          </div>
          <emoji-container
            @emoji="insert"
            v-if="isAuth"
          />
          <div
            class="chat-footer-button"
            v-if="isAuth"
          >
            <button
              type="submit"
              :disabled="sending"
            >
              <span v-if="!sending">SEND</span>

              <loader v-else></loader>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import EmojiPicker from 'vue-emoji-picker';
import Loader from '../../shared/loader.vue';
import EmojiContainer from '../../shared/emoji-container.vue';
export default {
  name: 'Comments',
  components: {
    loader: Loader,
    EmojiContainer,
    EmojiPicker,
  },
  props: {
    playlist_id: {
      type: Number,
      required: true,
    },
    show_comments: {
      type: Boolean,
      required: false,
      default: false,
    },
    isAuth: {
      type: Boolean,
      required: true,
      default: false,
    },
    single: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data() {
    return {
      comments: [],
      hide: false,
      message: '',
      sending: false,
      loginToChatLang: 'You need to be logged in order to give a comment.',
    };
  },
  mounted() {
    this.getComments();
  },
  methods: {
    insert(emoji) {
      this.message += emoji;
    },
    getComments() {
      var url = `/flix/playlist/${this.playlist_id}/comments`;
      if (this.single) {
        url = `/item/${this.playlist_id}/comments`;
      }
      axios
        .get(url)
        .then((response) => {
          this.comments = response.data.comments;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    handleHideModal() {
      this.$emit('hideModal');
    },
    send_message() {
      const payload = {
        comment: this.message,
      };
      
      var url = `/flix/playlist/${this.playlist_id}/comments`;
      if (this.single) {
        url = `/item/${this.playlist_id}/comment`;
      }
      axios
        .post(url, {
          ...payload,
        })
        .then((response) => {
          this.comments.push({
            comment: this.message,
            commentator: {
              firstname: 'You',
              lastname: '',
            },
          });
          this.message = '';
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>

<style scoped lang="scss">
.close-btn {
  background-color: transparent !important;
  border: 1px solid;
  border-radius: 5px !important;
}

.chat-body {
  height: 300px;
  overflow-y: scroll;
  padding: 10px;

  .chat-body-message {
    display: flex;
    margin-bottom: 10px;

    .user-profile {
      width: 25px;
      height: 25px;
      border-radius: 50%;
      margin-right: 10px;
    }

    .chat-body-message-content {
      background-color: #2a2a2a;
      padding: 8px;
      border-radius: 8px;
      width: 100%;
      font-size: 13px;
      word-break: break-word;

      .sender-name {
        color: #e2e8f0;
        font-size: 13px;
        font-weight: 500;
      }
    }
  }
}

.chat-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  border-top: 1px solid var(--color-grayish-white);

  .chat-footer-warning {
    color: #e53e3e;
    font-size: 13px;
    font-weight: 500;
    text-align: center;
    width: 100%;
  }

  .chat-footer-input {
    width: 100%;
    margin-right: 15px;

    input {
      width: 100%;
      padding: 10px;
      padding-right: 26px !important;
      border-radius: 8px;
      border: 1px solid var(--color-grayish-white);
      background-color: #141619;
      color: #e2e8f0;
      font-size: 13px;

      &:focus {
        border: 1px solid #43527a;
      }
    }
  }

  .chat-footer-button {
    button {
      padding: 10px 20px;
      border-radius: 8px;
      border: 1px solid var(--color-grayish-white);
      background-color: var(--color-grayish-white);
      color: #e2e8f0;
      font-size: 13px;
      cursor: pointer;
      transition: 0.2s;

      &:hover {
        background-color: var(--color-grayish);
      }
    }
  }
}

.wrapper {
  position: relative;
  display: inline-block;
}
</style>
